var ModalBackdropOptions = (function () {
    function ModalBackdropOptions(options) {
        this.animate = true;
        Object.assign(this, options);
    }
    return ModalBackdropOptions;
}());
export { ModalBackdropOptions };
//# sourceMappingURL=modal-backdrop.options.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/ngx-bootstrap/modal/modal-backdrop.options.js
// module id = ../../../../ngx-bootstrap/modal/modal-backdrop.options.js
// module chunks = 5